//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function () {
    return {
      filterPrices: {...this.filterPrice},
      filterSelected: {...this.selectedFilters},
    }
  },

  props: {
    filter: {
      type: Array,
      default: () => {
        return []
      }
    },
    category: {
      type: Object,
      default: () => {
        return {}
      }
    },
    filterPrice: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selectedFilters: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isMobile: {
      type: Boolean,
      default: false
    },
    isShowFilterSelected: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    filterSex: function () {
      const _filter = (this.filter || []).find((t) => t.slug === 'pol');
      if (!_filter) return null
      return _filter
    },
    filterItems: function () {
      let list = [...this.filter];
      list = list.filter((t) => !Boolean(['pol'].includes(t.slug)));

      let rangeFrameSizeItems = list.filter((t) => ['range_frame_size'].includes(t.filterTemplate));
      if (rangeFrameSizeItems.length > 0) {
        list = list.filter((t) => !Boolean(['range_frame_size'].includes(t.filterTemplate)))
        list.push({
          name: "Размер оправы",
          slug: "range_frame_size",
          filterTemplate: "range_frame_size",
          urlSort: list?.[0]?.urlSort || 999,
          children: rangeFrameSizeItems || []
        });
      }

      return list
      // list = list.sort((a, b) => {
      //   if (a?.urlSort < b?.urlSort) {
      //     return 1
      //   }
      //   if (a?.urlSort > b?.urlSort) {
      //     return -1
      //   }
      //   return 0
      // });
      // return list
    },

    isShowFilterPrice: function () {
      return Boolean(Object.keys(this.filterPrice || {}).length > 0)
    }
  },

  components: {
    FilterSelected: () => import('~/components/catalog-new/FilterSelected.vue'),
    FilterTagsComponent: () => import("~/components/catalog-new/FilterTags.vue"),
    FilterSizeComponent: () => import("~/components/catalog-new/FilterSizes.vue"),
    FilterPriceComponent: () => import("~/components/catalog-new/FilterPrice.vue"),
    FilterSwitchComponent: () => import("~/components/catalog-new/FilterSwitch.vue")
  },

  watch: {
    filterPrice: function () {
      this.filterPrices = {...this.filterPrice};
    },
    selectedFilters: function () {
      this.filterSelected = {...this.selectedFilters};
    },
  },

  methods: {
    tapVariant: function (filterSlug, variantSlug, isDisabled) {
      if (isDisabled) {
        return null
      }

      // Изменение текущего фильтра
      let filterSelected = { ...this.filterSelected }
      if (Boolean(filterSelected?.[filterSlug]?.[variantSlug])) {
        delete filterSelected?.[filterSlug]?.[variantSlug]

        if (Object.keys(filterSelected?.[filterSlug] || {}).length <= 0) {
          delete filterSelected?.[filterSlug]
        }
      } else {
        filterSelected[filterSlug] = {
          ...(filterSelected[filterSlug] || {}),
          [variantSlug]: variantSlug
        }
      }


      this.filterSelected = filterSelected
      this.$emit('requestUpdateFilter', filterSelected)
    },

    changeFilterPrices: function (range) {
      let newSelectedPrices = [...(this.filterPrices?.selectedPrices || [])]
      newSelectedPrices[0] = range[0]
      newSelectedPrices[1] = range[1]
      this.filterPrices.selectedPrices = newSelectedPrices;

      let filterSelected = { ...this.filterSelected };
      if (!!range[0]) {
        filterSelected['priceFrom'] = {
          [range[0]]: range[0]
        };
      } else {
        delete filterSelected['priceFrom']
      }
      if (!!range[1]) {
        filterSelected['priceTo'] = {
          [range[1]]: range[1]
        };
      } else {
        delete filterSelected['priceTo']
      }
      this.$emit('requestUpdateFilter', filterSelected)
    },
    changeFilterSize: function (values, filterItem) {
      const isRemoved = Boolean(!values?.[0] && !values?.[1]);

      let filterSelected = { ...this.filterSelected };
      if (isRemoved) {
        delete filterSelected[filterItem?.slug];
      } else {
        let valuesJoin = [...values].join(':');
        filterSelected[filterItem.slug] = {
          [valuesJoin]: valuesJoin
        };
      }

      this.filterSelected = filterSelected
      this.$emit('requestUpdateFilter', filterSelected)
    },

    fastUpdate: function (filters = {}) {
      this.$emit('fastUpdate', filters);
    },
  }
}
